// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"4a5e5e0d","977":"5994ab69"}[chunkId] + ".chunk.js";
};